export default {
    contractListItem: {
        noCounterparty: '(nema druge strane)',
        viewPosition: 'Prikaži poziciju',
    },
}
